<template>
	<div>
      
      <nav-header></nav-header>
		  <!--Area Start -->

      <div class="container">
        <slot></slot> <!-- this is where the content is added from the page--> 
      </div>
      
	</div>
</template>

<script>
import navHeader from './header'

export default {

  name: 'layout',

  components: {
    'nav-header': navHeader,
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>